/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2022] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import tmplOrderDeviceAdminItemView from './OrderDeviceAdminItemView.hbs';
import './OrderDeviceAdminItemView.css';

const OrderDeviceAdminItemView = View.extend({
  template: tmplOrderDeviceAdminItemView,

  className: 'order-device-item-view pt-2 pb-4 px-4',

  ui: {
    price: '.price',
    quantity: '.quantity',
    totalPrice: '.item-total-cost',
    image: 'img'
  },

  initialize() {

    let productName;
    if (this.model.get('isNIPR') === '1') {
      productName = `${this.model.get('model')} NIPR`
    } else if (this.model.get('isNIPR') === '0') {
      productName = `${this.model.get('model')} SIPR`
    } else {
      productName = this.model.get('model');
    }

    this.model.set({
      productName,
      totalPrice: this.model.get('totalPrice') || '0',
      quantity: this.model.get('quantity') || '0'
    });
  }
});

export default OrderDeviceAdminItemView;
